module.exports = __webpack_public_path__ + "static/media/11.786ac8d9.jpg";